module.exports = __webpack_public_path__ + "img/banner1_1.57d8c8c1.png";